import { WALLETS } from '@/modules/networks/mocks/wallets'
import type { WalletGroup } from '../types'

export const WALLET_GROUPS: WalletGroup[] = [
  {
    id: '1',
    name: 'Core',
    wallets: WALLETS,
  },
  {
    id: '2',
    name: 'Ops',
    wallets: WALLETS,
  },
]

export const ATLAS_BUDGETS = [
  {
    id: '1',
    parentId: null,
    name: 'Atlas Immutable Budget',
    code: 'atlas/immutable',
    idPath: '1',
    codePath: 'atlas/immutable',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/endgame_atlas_budgets.svg',
    description: 'Endgame constitutional expense data as defined in the Sky Atlas.',
  },
  {
    id: '2',
    parentId: '1',
    name: 'SKY',
    code: 'SKY',
    idPath: '1/2',
    codePath: 'atlas/immutable/SKY',
    image: '',
    description:
      'Emmisions and Distribution: the Neural Tokenomics emits up to 1 billion SKY per year to power all the tokenomics of the SkyDAO System [ATL.4.3.11]',
  },
  {
    id: '3',
    parentId: '2',
    name: 'Neural tokenomics',
    code: 'NTE',
    idPath: '1/2/3',
    codePath: 'atlas/immutable/SKY/NTE',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/subDAOs.svg',
    description:
      'Emissions on the New Chain: 900 million SKY per year are recaptured by driving users or income to the protocol [ATL.4.3.11.1]',
  },
  {
    id: '4',
    parentId: '3',
    name: 'AllocatorDAO Axon',
    code: 'AA',
    idPath: '1/2/3/4',
    codePath: 'atlas/immutable/SKY/NTE/AA',
    image: '',
    description:
      'AllocatorDAO Axon will distribute 460million SKY  to the AllocatorDAOs based on the AllocatorDAOs Elixir holdings [ATL.4.3.11.1.1]',
  },
  {
    id: '5',
    parentId: '3',
    name: 'FacilitatorDAO Responsability Rewards',
    code: 'FRR',
    idPath: '1/2/3/5',
    codePath: 'atlas/immutable/SKY/NTE/FRR',
    image: '',
    description:
      '150 million NGT are sent to the FacilitatorDAO Responsibility Reward system from where it is distributed to FacilitatorDAOs based on their scope responsibilities. [ATL.4.3.11.1.2]',
  },
  {
    id: '6',
    parentId: '5',
    name: 'SkyDAO Scope FacilitatorDAO Responsibility Rewards',
    code: 'fdsm',
    idPath: '1/2/3/5/6',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdsm',
    image: '',
    description: '',
  },
  {
    id: '7',
    parentId: '6',
    name: 'Stability Scope Weight 3',
    code: 'STA',
    idPath: '1/2/3/5/6/7',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdsm/STA',
    image: '',
    description: '',
  },
  {
    id: '8',
    parentId: '6',
    name: 'Support Scope Weight 3',
    code: 'SUP',
    idPath: '1/2/3/5/6/8',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdsm/SUP',
    image: '',
    description: '',
  },
  {
    id: '9',
    parentId: '6',
    name: 'Protocol Scope Weight 1',
    code: 'PRO',
    idPath: '1/2/3/5/6/9',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdsm/PRO',
    image: '',
    description: '',
  },
  {
    id: '10',
    parentId: '6',
    name: 'Accessibility Scope Weight 1',
    code: 'ACC',
    idPath: '1/2/3/5/6/10',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdsm/ACC',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/subDAOs.svg',
    description: '',
  },
  {
    id: '11',
    parentId: '6',
    name: 'Scopes Budget Weight',
    code: 'SBW',
    idPath: '1/2/3/5/6/11',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdsm/SBW',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/subDAOs.svg',
    description: '',
  },
  {
    id: '12',
    parentId: '6',
    name: 'Scopes Minimum Treshold',
    code: 'SMT',
    idPath: '1/2/3/5/6/12',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdsm/SMT',
    image: '',
    description: '',
  },
  {
    id: '13',
    parentId: '5',
    name: 'SubDAO Scope FacilitatorDAO Responsibility Rewards',
    code: 'fdss',
    idPath: '1/2/3/5/13',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdss',
    image: '',
    description: '',
  },
  {
    id: '14',
    parentId: '13',
    name: 'SubDAO Scopes AllocatorDAO Weight',
    code: 'SSAW',
    idPath: '1/2/3/5/13/14',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdss/SSAW',
    image: '',
    description: '',
  },
  {
    id: '15',
    parentId: '13',
    name: 'SubDAO Scopes MiniDAO Weight Conditioned to Elixir holdings',
    code: 'SSMW',
    idPath: '1/2/3/5/13/15',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdss/SSMW',
    image: '',
    description: '',
  },
  {
    id: '16',
    parentId: '13',
    name: 'SubDAO Scopes Responsability',
    code: 'SSR',
    idPath: '1/2/3/5/13/16',
    codePath: 'atlas/immutable/SKY/NTE/FRR/fdss/SSR',
    image: '',
    description: '',
  },
  {
    id: '17',
    parentId: '3',
    name: 'FacilitatorDAO Axon',
    code: 'FA',
    idPath: '1/2/3/17',
    codePath: 'atlas/immutable/SKY/NTE/FA',
    image: '',
    description:
      '120 million SKY are sent to the FacilitatorDAO Axon and distributed to the FacilitatorDAOs based on the FacilitatorDAOs Elixir holdings [ATL.4.3.11.1.3]',
  },
  {
    id: '18',
    parentId: '3',
    name: 'Dai NewGovToken Farming',
    code: 'DNF',
    idPath: '1/2/3/18',
    codePath: 'atlas/immutable/SKY/NTE/DNF',
    image: '',
    description: '100 million SKY are available in the standard Dai Farms [ATL.4.3.11.1.4]',
  },
  {
    id: '19',
    parentId: '3',
    name: 'SubDAO Incubation',
    code: 'SI',
    idPath: '1/2/3/19',
    codePath: 'atlas/immutable/SKY/NTE/SI',
    image: '',
    description:
      '70 million SKY per year accumalates in the Incubators reserve burn engine and are used to fund the launch of the next SubDAO [ATL.4.3.11.1.5]',
  },
  {
    id: '20',
    parentId: '3',
    name: 'Governance Upkeep',
    code: 'GU',
    idPath: '1/2/3/20',
    codePath: 'atlas/immutable/SKY/NTE/GU',
    image: '',
    description:
      '100 million SKY are for Governanve Upkeep and will not be recaptured [ATL.4.3.11.2]',
  },
  {
    id: '21',
    parentId: '20',
    name: 'Purpose System',
    code: 'PS',
    idPath: '1/2/3/20/21',
    codePath: 'atlas/immutable/SKY/NTE/GU/PS',
    image: '',
    description:
      '30 million SKY per year are accumulated in the Purpose Fund account, from where it is disdtributed to on of the AllocatorDAOs each year, based on their public impact performance. [ATL.4.3.11.2.2]',
  },
  {
    id: '22',
    parentId: '20',
    name: 'Validator Operation Rewards',
    code: 'VOR',
    idPath: '1/2/3/20/22',
    codePath: 'atlas/immutable/SKY/NTE/GU/VOR',
    image: '',
    description:
      '20 million SKY per year are distributed in staking rewards to the NewChain validators. These rewards do not go to Sagittarius Engine Lockstakers, who automatically stake to the Validators through their chosen delegates. ',
  },
  {
    id: '23',
    parentId: '20',
    name: 'Aligned Voter Committees',
    code: 'AVC',
    idPath: '1/2/3/20/23',
    codePath: 'atlas/immutable/SKY/NTE/GU/AVC',
    image: '',
    description:
      '20 million SKY per year are for the Aligned Voter Committee Member Reward. The distribution is set to 1million for each Scope per quarterly governance cycle shared acrross the reward slots for the specific Scope. [ATL.2.5.10.2]',
  },
  {
    id: '24',
    parentId: '23',
    name: 'Stability Scope',
    code: 'STA',
    idPath: '1/2/3/20/23/24',
    codePath: 'atlas/immutable/SKY/NTE/GU/AVC/STA',
    image: '',
    description:
      'Aligned Voter Committees Budget: Funds allocated to cover costs related to AVC member participation rewards that recognizes the time AVC members spend to support Maker Governance. Atl.2.5.10.2',
  },
  {
    id: '25',
    parentId: '23',
    name: 'Support Scope',
    code: 'SUP',
    idPath: '1/2/3/20/23/25',
    codePath: 'atlas/immutable/SKY/NTE/GU/AVC/SUP',
    image: '',
    description:
      'Aligned Voter Committees Budget: Funds allocated to cover costs related to AVC member participation rewards that recognizes the time AVC members spend to support Maker Governance. Atl.2.5.10.2',
  },
  {
    id: '26',
    parentId: '23',
    name: 'Protocol Scope',
    code: 'PRO',
    idPath: '1/2/3/20/23/26',
    codePath: 'atlas/immutable/SKY/NTE/GU/AVC/PRO',
    image: '',
    description:
      'Aligned Voter Committees Budget: Funds allocated to cover costs related to AVC member participation rewards that recognizes the time AVC members spend to support Maker Governance. Atl.2.5.10.2',
  },
  {
    id: '27',
    parentId: '23',
    name: 'Accessibility Scope',
    code: 'ACC',
    idPath: '1/2/3/20/23/27',
    codePath: 'atlas/immutable/SKY/NTE/GU/AVC/ACC',
    image: '',
    description:
      'Aligned Voter Committees Budget: Funds allocated to cover costs related to AVC member participation rewards that recognizes the time AVC members spend to support Maker Governance. Atl.2.5.10.2',
  },
  {
    id: '28',
    parentId: '23',
    name: 'Governance Scope',
    code: 'GOV',
    idPath: '1/2/3/20/23/28',
    codePath: 'atlas/immutable/SKY/NTE/GU/AVC/GOV',
    image: '',
    description:
      'Aligned Voter Committees Budget: Funds allocated to cover costs related to AVC member participation rewards that recognizes the time AVC members spend to support Maker Governance. Atl.2.5.10.2',
  },
  {
    id: '29',
    parentId: '1',
    name: 'Aligned Delegates',
    code: 'aligned-delegates',
    idPath: '1/29',
    codePath: 'atlas/immutable/aligned-delegates',
    image: '',
    description:
      'Aligned Delegates (ADs) are anonymous Alignment Conservers (AC) who operate as delegates.  ',
  },
  {
    id: '30',
    parentId: '29',
    name: 'Prime Delegates',
    code: 'prime-delegates',
    idPath: '1/29/30',
    codePath: 'atlas/immutable/aligned-delegates/prime-delegates',
    image: '',
    description:
      '30 million NGT per year are for Prime Delegates and paid out through the AD PDMs [ATL.4.3.11.2.1]',
  },
  {
    id: '31',
    parentId: '30',
    name: 'Stability Scope',
    code: 'STA',
    idPath: '1/29/30/31',
    codePath: 'atlas/immutable/aligned-delegates/prime-delegates/STA',
    image: '',
    description:
      'Prime Delegates Budget: Funds allocated to participation rewards for the Prime Delegates time spent operating Governance Strategy Links (GSLs). Atl.2.6.3.9',
  },
  {
    id: '32',
    parentId: '30',
    name: 'Support Scope',
    code: 'SUP',
    idPath: '1/29/30/32',
    codePath: 'atlas/immutable/aligned-delegates/prime-delegates/SUP',
    image: '',
    description:
      'Prime Delegates Budget: Funds allocated to participation rewards for the Prime Delegates time spent operating Governance Strategy Links (GSLs). Atl.2.6.3.9',
  },
  {
    id: '33',
    parentId: '30',
    name: 'Protocol Scope',
    code: 'PRO',
    idPath: '1/29/30/33',
    codePath: 'atlas/immutable/aligned-delegates/prime-delegates/PRO',
    image: '',
    description:
      'Prime Delegates Budget: Funds allocated to participation rewards for the Prime Delegates time spent operating Governance Strategy Links (GSLs). Atl.2.6.3.9',
  },
  {
    id: '34',
    parentId: '30',
    name: 'Accessibility Scope',
    code: 'ACC',
    idPath: '1/29/30/34',
    codePath: 'atlas/immutable/aligned-delegates/prime-delegates/ACC',
    image: '',
    description:
      'Prime Delegates Budget: Funds allocated to participation rewards for the Prime Delegates time spent operating Governance Strategy Links (GSLs). Atl.2.6.3.9',
  },
  {
    id: '35',
    parentId: '30',
    name: 'Governance Scope',
    code: 'GOV',
    idPath: '1/29/30/35',
    codePath: 'atlas/immutable/aligned-delegates/prime-delegates/GOV',
    image: '',
    description:
      'Prime Delegates Budget: Funds allocated to participation rewards for the Prime Delegates time spent operating Governance Strategy Links (GSLs). Atl.2.6.3.9',
  },
  {
    id: '36',
    parentId: '29',
    name: 'Reserve Delegates',
    code: 'reserve-delegates',
    idPath: '1/29/36',
    codePath: 'atlas/immutable/aligned-delegates/reserve-delegates',
    image: '',
    description:
      '10 million NGT per year are for Reserve Delegates and paid out through the AD PDMs [ATL.4.3.11.2.4].',
  },
  {
    id: '37',
    parentId: '36',
    name: 'Stability Scope',
    code: 'STA',
    idPath: '1/29/36/37',
    codePath: 'atlas/immutable/aligned-delegates/reserve-delegates/STA',
    image: '',
    description:
      'Reserve Aligned Delegates Budget: Funds allocated to cover costs related to AD participation rewards that recognizes the time spend to operate Governance Strategy Links (GSLs) [ATL.4.3.11.2.4].',
  },
  {
    id: '38',
    parentId: '36',
    name: 'Support Scope',
    code: 'SUP',
    idPath: '1/29/36/38',
    codePath: 'atlas/immutable/aligned-delegates/reserve-delegates/SUP',
    image: '',
    description:
      'Reserve Aligned Delegates Budget: Funds allocated to cover costs related to AD participation rewards that recognizes the time spend to operate Governance Strategy Links (GSLs) [ATL.4.3.11.2.4].',
  },
  {
    id: '39',
    parentId: '36',
    name: 'Protocol Scope',
    code: 'PRO',
    idPath: '1/29/36/39',
    codePath: 'atlas/immutable/aligned-delegates/reserve-delegates/PRO',
    image: '',
    description:
      'Reserve Aligned Delegates Budget: Funds allocated to cover costs related to AD participation rewards that recognizes the time spend to operate Governance Strategy Links (GSLs) [ATL.4.3.11.2.4].',
  },
  {
    id: '40',
    parentId: '36',
    name: 'Accessibility Scope',
    code: 'ACC',
    idPath: '1/29/36/40',
    codePath: 'atlas/immutable/aligned-delegates/reserve-delegates/ACC',
    image: '',
    description:
      'Reserve Aligned Delegates Budget: Funds allocated to cover costs related to AD participation rewards that recognizes the time spend to operate Governance Strategy Links (GSLs) [ATL.4.3.11.2.4].',
  },
  {
    id: '41',
    parentId: '36',
    name: 'Governance Scope',
    code: 'GOV',
    idPath: '1/29/36/41',
    codePath: 'atlas/immutable/aligned-delegates/reserve-delegates/GOV',
    image: '',
    description:
      'Reserve Aligned Delegates Budget: Funds allocated to cover costs related to AD participation rewards that recognizes the time spend to operate Governance Strategy Links (GSLs) [ATL.4.3.11.2.4].',
  },
  {
    id: '42',
    parentId: '1',
    name: 'AllocatorDAO',
    code: 'ALD',
    idPath: '1/42',
    codePath: 'atlas/immutable/ALD',
    image: '',
    description:
      'Genesis Emissions, Distribution and Farming rate: 2.3 billion tokens are emitted for farming, 70% for Dai Farming and for 30% Sagittarius Engine [ATL.4.3.12.2]',
  },
  {
    id: '43',
    parentId: '42',
    name: 'AllocatorDAO tokens',
    code: 'ALT',
    idPath: '1/42/43',
    codePath: 'atlas/immutable/ALD/ALT',
    image: '',
    description: '2 billion Allocator tokens are for Genesis farming [ATL.4.3.12.2.1]',
  },
  {
    id: '44',
    parentId: '43',
    name: 'The rate of the First Two years of Genesis Farming',
    code: 'R2',
    idPath: '1/42/43/44',
    codePath: 'atlas/immutable/ALD/ALT/R2',
    image: '',
    description: '',
  },
  {
    id: '45',
    parentId: '43',
    name: 'The rate of the Third and Fourth years of Genesis Farming',
    code: 'R4',
    idPath: '1/42/43/45',
    codePath: 'atlas/immutable/ALD/ALT/R4',
    image: '',
    description: '',
  },
  {
    id: '46',
    parentId: '43',
    name: 'The rate of the Fifth and Sixth years of Genesis Farming',
    code: 'R6',
    idPath: '1/42/43/46',
    codePath: 'atlas/immutable/ALD/ALT/R6',
    image: '',
    description: '',
  },
  {
    id: '47',
    parentId: '43',
    name: 'The rate of the Seventh, Eighth, Ninth and Tenth of Genesis Farming',
    code: 'R10',
    idPath: '1/42/43/47',
    codePath: 'atlas/immutable/ALD/ALT/R10',
    image: '',
    description: '',
  },
  {
    id: '48',
    parentId: '42',
    name: 'The Workforce Bonus Pool',
    code: 'WBP',
    idPath: '1/42/48',
    codePath: 'atlas/immutable/ALD/WBP',
    image: '',
    description:
      'The workforce bonus pool starts with 300 million AllocatorDAO tokens and can be further topped up through the permanent emissions [ATL.4.3.12.2.2]',
  },
  {
    id: '49',
    parentId: '1',
    name: 'FacilitatorDAO',
    code: 'FLD',
    idPath: '1/49',
    codePath: 'atlas/immutable/FLD',
    image: '',
    description:
      'Genesis Emissions, Distribution and Farming rate: 2.3 billion FacilitatorDAO tokens are emitted for farming, 70% for Dai Farming and for 30% Sagittarius Engine [ATL.4.3.12.2]',
  },
  {
    id: '50',
    parentId: '49',
    name: 'FacilitatorDAO tokens',
    code: 'FLT',
    idPath: '1/49/50',
    codePath: 'atlas/immutable/FLD/FLT',
    image: '',
    description: '2 billion FacilitatorDAO tokens are for Genesis farming [ATL.4.3.13.1]',
  },
  {
    id: '51',
    parentId: '50',
    name: 'The rate of the First Two years of Genesis Farming',
    code: 'R2',
    idPath: '1/49/50/51',
    codePath: 'atlas/immutable/FLD/FLT/R2',
    image: '',
    description:
      'For the first 2 years, the rate of Genesis farming is 500 million FacilitatorDAO tokens per year [ATL.4.3.13.2]',
  },
  {
    id: '52',
    parentId: '50',
    name: 'The rate of the Third and Fourth years of Genesis Farming',
    code: 'R4',
    idPath: '1/49/50/52',
    codePath: 'atlas/immutable/FLD/FLT/R4',
    image: '',
    description: '',
  },
  {
    id: '53',
    parentId: '50',
    name: 'The rate of the Fifth and Sixth years of Genesis Farming',
    code: 'R6',
    idPath: '1/49/50/53',
    codePath: 'atlas/immutable/FLD/FLT/R6',
    image: '',
    description: '',
  },
  {
    id: '54',
    parentId: '50',
    name: 'The rate of the Seventh, Eighth, Ninth and Tenth of Genesis Farming',
    code: 'R8',
    idPath: '1/49/50/54',
    codePath: 'atlas/immutable/FLD/FLT/R8',
    image: '',
    description: '',
  },
  {
    id: '55',
    parentId: '49',
    name: 'The Workforce Bonus Pool',
    code: 'WBP',
    idPath: '1/49/55',
    codePath: 'atlas/immutable/FLD/WBP',
    image: '',
    description:
      'The workforce bonus pool starts with 300 million FacilitatorDAO tokens and can be further topped up through the permanent emissions [ATL.4.3.13.2.2]',
  },
  {
    id: '56',
    parentId: '1',
    name: 'MiniDAO',
    code: 'MND',
    idPath: '1/56',
    codePath: 'atlas/immutable/MND',
    image: '',
    description:
      'Genesis Emissions, Distribution and Farming rate: 920 million MiniDAO tokens emitted for farming over 10 years. 15% of all MiniDAO tokens are for DAI Farming, 35% of all MiniDAO tokens are for regular farmers of the parent AllocatorDAO token and 50% of all MiniDAO tokens emmited are for parent AllocatorDAO lockstage Engine users. ',
  },
  {
    id: '57',
    parentId: '56',
    name: 'MiniDAO tokens',
    code: 'MNT',
    idPath: '1/56/57',
    codePath: 'atlas/immutable/MND/MNT',
    image: '',
    description: '',
  },
  {
    id: '58',
    parentId: '57',
    name: 'The rate of the First Two years of Genesis Farming',
    code: 'R2',
    idPath: '1/56/57/58',
    codePath: 'atlas/immutable/MND/MNT/R2',
    image: '',
    description: '',
  },
  {
    id: '59',
    parentId: '57',
    name: 'The rate of the Third and Fourth years of Genesis Farming',
    code: 'R4',
    idPath: '1/56/57/59',
    codePath: 'atlas/immutable/MND/MNT/R4',
    image: '',
    description: '',
  },
  {
    id: '60',
    parentId: '57',
    name: 'The rate of the Fifth and Sixth years of Genesis Farming',
    code: 'R6',
    idPath: '1/56/57/60',
    codePath: 'atlas/immutable/MND/MNT/R6',
    image: '',
    description: '',
  },
  {
    id: '61',
    parentId: '57',
    name: 'The rate of the Seventh, Eigth, Ninth and Tenth of Genesis Farming',
    code: 'R10',
    idPath: '1/56/57/61',
    codePath: 'atlas/immutable/MND/MNT/R10',
    image: '',
    description: '',
  },
  {
    id: '62',
    parentId: '56',
    name: 'The Workforce Bonus Pool',
    code: 'WBP',
    idPath: '1/56/62',
    codePath: 'atlas/immutable/MND/WBP',
    image: '',
    description: '',
  },
  {
    id: '63',
    parentId: null,
    name: 'Scope Framework Budget',
    code: 'atlas/scopes',
    idPath: '63',
    codePath: 'atlas/scopes',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/endgame_scope_budgets.svg',
    description:
      'Endgame operational expenses from the period 2023-2024, divided into five scopes.',
  },
  {
    id: '64',
    parentId: '63',
    name: 'Support Scope',
    code: 'SUP',
    idPath: '63/64',
    codePath: 'atlas/scopes/SUP',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description: 'Operational and Governance Support. ',
  },
  {
    id: '65',
    parentId: '64',
    name: 'Governance Process Support budget',
    code: 'GPS',
    idPath: '63/64/65',
    codePath: 'atlas/scopes/SUP/GPS',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'The Governance Process Support Budget: Funds allocated to cover costs related to administrative support and services [SUP.2.5.1.1B].',
  },
  {
    id: '66',
    parentId: '64',
    name: 'GAIT bootstrapping budget',
    code: 'GAIT-B',
    idPath: '63/64/66',
    codePath: 'atlas/scopes/SUP/GAIT-B',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Governance Artificial Intelligence Bootstrapping "GAIT" Budget: Funds allocated to cover costs  related to research [SUP.4.3.1.1B].',
  },
  {
    id: '67',
    parentId: '64',
    name: 'GAIT Hardware and maintenance budget',
    code: 'GAIT-H',
    idPath: '63/64/67',
    codePath: 'atlas/scopes/SUP/GAIT-H',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Governance Artificial Intelligence Bootstrapping "GAIT" Budget: Funds allocated to cover costs related to hardware [SUP.4.3.2.1B].',
  },
  {
    id: '68',
    parentId: '64',
    name: 'DAO Toolkit Core Development',
    code: 'DTK',
    idPath: '63/64/68',
    codePath: 'atlas/scopes/SUP/DTK',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'DAO Toolkit Budget: Funds allocated to cover costs related to the development of the core underlying software and modules of the DAO Toolkit that is used to implement the Scope Frameworks as software [SUP.3.1.1B].',
  },
  {
    id: '69',
    parentId: '64',
    name: 'Communications infrastructure budget',
    code: 'C-INF',
    idPath: '63/64/69',
    codePath: 'atlas/scopes/SUP/C-INF',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'The Communications Infrastructure Budget: Funds allocated to cover costs related to the ecosystem communication infrastructure such as the forum and chat platform [SUP.8.3.1B].',
  },
  {
    id: '70',
    parentId: '64',
    name: 'Ecosystem Agreement Enforcement overhead budget',
    code: 'EAE',
    idPath: '63/64/70',
    codePath: 'atlas/scopes/SUP/EAE',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Ecosystem Agreement Enforcement Overhead Budget: Funds allocated to cover costs related to Ecosystem Agreement disputes [SUP.9.2.1].',
  },
  {
    id: '71',
    parentId: '64',
    name: 'Resilience Fund',
    code: 'RF',
    idPath: '63/64/71',
    codePath: 'atlas/scopes/SUP/RF',
    image: '',
    description: '',
  },
  {
    id: '72',
    parentId: '71',
    name: 'Resilience Fund',
    code: 'resilience-fund',
    idPath: '63/64/71/72',
    codePath: 'atlas/scopes/SUP/RF/resilience-fund',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'The Resilience Fund Budget: Funds allocated to cover costs  related to legal or regulatory action against the DAO or active participants in the Maker ecosystem [SUP.10.1.1.1A].',
  },
  {
    id: '73',
    parentId: '71',
    name: 'Gallagher',
    code: 'GAL',
    idPath: '63/64/71/73',
    codePath: 'atlas/scopes/SUP/RF/GAL',
    image: '',
    description: 'Technical Committee ',
  },
  {
    id: '74',
    parentId: '64',
    name: 'The Resilience Research and Preparedness Budget',
    code: 'RRP-F',
    idPath: '63/64/74',
    codePath: 'atlas/scopes/SUP/RRP-F',
    image: '',
    description: '',
  },
  {
    id: '75',
    parentId: '74',
    name: 'The Resilience Research and Preparedness Budget',
    code: 'research-preparedness',
    idPath: '63/64/74/75',
    codePath: 'atlas/scopes/SUP/RRP-F/research-preparedness',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'The Resilience Research and Preparedness Budget: Funds allocated to cover costs  related to legal uncertainty and risk research [SUP.11.1.1B].',
  },
  {
    id: '76',
    parentId: '74',
    name: 'Gallagher',
    code: 'GAL',
    idPath: '63/64/74/76',
    codePath: 'atlas/scopes/SUP/RRP-F/GAL',
    image: '',
    description: '',
  },
  {
    id: '77',
    parentId: '64',
    name: 'Purpose fund',
    code: 'PR-F',
    idPath: '63/64/77',
    codePath: 'atlas/scopes/SUP/PR-F',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Purpose System Budget: Funds allocated to charity and public good campaigns that promote responsible, open source AI development and publich good impact of open AI software [SUP.12.2].',
  },
  {
    id: '78',
    parentId: '64',
    name: 'Incubation overhead budget',
    code: 'IO',
    idPath: '63/64/78',
    codePath: 'atlas/scopes/SUP/IO',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Incubation Overhead Budget: Funds allocated to cover the costs related to the review of Incubation Proposals [SUP.7.2.1.1B].',
  },
  {
    id: '79',
    parentId: '64',
    name: 'Incubation budget',
    code: 'INC',
    idPath: '63/64/79',
    codePath: 'atlas/scopes/SUP/INC',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Incubation Budget: Funds allocated to cover the costs of Incubation [SUP.7.2.2.1B].',
  },
  {
    id: '80',
    parentId: '79',
    name: 'Phoenix Labs',
    code: 'PHX-001',
    idPath: '63/64/79/80',
    codePath: 'atlas/scopes/SUP/INC/PHX-001',
    image: '',
    description: '',
  },
  {
    id: '81',
    parentId: '80',
    name: 'Phoenix Labs',
    code: 'PHX-001.a',
    idPath: '63/64/79/80/81',
    codePath: 'atlas/scopes/SUP/INC/PHX-001/PHX-001.a',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Phoenix Labs Budget: Funds allocated to cover costs related to the delivery of the Spark Protocol including 12 months of Spark Protocol maintenance, and SubDAO launch support.[N/A]',
  },
  {
    id: '82',
    parentId: '80',
    name: 'Phoenix Labs',
    code: 'PHX-001.b',
    idPath: '63/64/79/80/82',
    codePath: 'atlas/scopes/SUP/INC/PHX-001/PHX-001.b',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Phoenix Labs Budget: Funds allocated to cover costs  related to the delivery of the Spark Protocol including 12 months of Spark Protocol maintenance, and SubDAO launch support [SUP.7.4.2.1A].',
  },
  {
    id: '83',
    parentId: '80',
    name: 'Phoenix Labs',
    code: 'PHX-001.c',
    idPath: '63/64/79/80/83',
    codePath: 'atlas/scopes/SUP/INC/PHX-001/PHX-001.c',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Phoenix Labs Budget: Funds allocated to cover costs  related to the delivery of the Spark Protocol including 12 months of Spark Protocol maintenance, and SubDAO launch support [SUP.7.4.2.1A].',
  },
  {
    id: '84',
    parentId: '79',
    name: 'Viridian Protector Advisor Company',
    code: 'VPAC-001',
    idPath: '63/64/79/84',
    codePath: 'atlas/scopes/SUP/INC/VPAC-001',
    image: '',
    description: '',
  },
  {
    id: '85',
    parentId: '84',
    name: 'Viridian Protector Advisor Company',
    code: 'VPAC-001.a',
    idPath: '63/64/79/84/85',
    codePath: 'atlas/scopes/SUP/INC/VPAC-001/VPAC-001.a',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Viridian Protector Advisory Company: Funds allocated to cover cost related to protector advisor work [SUP.7.4.2.1A].',
  },
  {
    id: '86',
    parentId: '84',
    name: 'Viridian Protector Advisor Company',
    code: 'VPAC-001.b',
    idPath: '63/64/79/84/86',
    codePath: 'atlas/scopes/SUP/INC/VPAC-001/VPAC-001.b',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Viridian Protector Advisory Company: Funds allocated to cover cost related to protector advisor work [SUP.7.4.2.1A].',
  },
  {
    id: '87',
    parentId: '79',
    name: 'Chronicle Labs',
    code: 'CHL-001',
    idPath: '63/64/79/87',
    codePath: 'atlas/scopes/SUP/INC/CHL-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Chronicle Labs Budget: Funds allocated to cover costs  related to the Launch of a suistainable secure decentralized protocol and infrastructure service provides which supports the needs of SubDAOs [SUP.7.4.2.1A].',
  },
  {
    id: '88',
    parentId: '79',
    name: 'TECH',
    code: 'TCH-001',
    idPath: '63/64/79/88',
    codePath: 'atlas/scopes/SUP/INC/TCH-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description: '',
  },
  {
    id: '89',
    parentId: '63',
    name: 'Stability Scope',
    code: 'STA',
    idPath: '63/89',
    codePath: 'atlas/scopes/STA',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/stability_scope(STA).svg',
    description: 'Financial Stability Management ',
  },
  {
    id: '90',
    parentId: '89',
    name: 'The Stability Advisory Council Projects and Funding',
    code: 'STAC',
    idPath: '63/89/90',
    codePath: 'atlas/scopes/STA/STAC',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/stability_scope(STA).svg',
    description:
      'The Stability Advisory Council Project Funding: is used to cover costs  related to Advisory Council projects to do specific work that improves all or specific parts of the Scope Framework [Sta.1.1.3].',
  },
  {
    id: '91',
    parentId: '90',
    name: 'BALabs',
    code: 'BAL-001',
    idPath: '63/89/90/91',
    codePath: 'atlas/scopes/STA/STAC/BAL-001',
    image: '',
    description:
      'BA Labs Budget: Funds allocated to cover costs related to the advisory council projects and data. . ',
  },
  {
    id: '92',
    parentId: '91',
    name: 'BALabs Budget Stream 1',
    code: 'BAL-001.a',
    idPath: '63/89/90/91/92',
    codePath: 'atlas/scopes/STA/STAC/BAL-001/BAL-001.a',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/stability_scope(STA).svg',
    description:
      'Funds allocated to cover costs related to the advisory council projects [Sta.1.1.5.1B].',
  },
  {
    id: '93',
    parentId: '91',
    name: 'BALabs Budget Stream 2',
    code: 'BAL-001.b',
    idPath: '63/89/90/91/93',
    codePath: 'atlas/scopes/STA/STAC/BAL-001/BAL-001.b',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/stability_scope(STA).svg',
    description: 'BA Labs Budget: Funds allocated to cover costs related to data [Sta.1.1.5.1B].',
  },
  {
    id: '94',
    parentId: '90',
    name: 'ALM and RWA related projects',
    code: 'ACPB',
    idPath: '63/89/90/94',
    codePath: 'atlas/scopes/STA/STAC/ACPB',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/stability_scope(STA).svg',
    description: 'Advisory Council Project Budget for ALM and RWA related expenses.',
  },
  {
    id: '95',
    parentId: '89',
    name: 'Legal Recourse Asset Budget',
    code: 'LRA',
    idPath: '63/89/95',
    codePath: 'atlas/scopes/STA/LRA',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/stability_scope(STA).svg',
    description:
      'Legal Recourse Asset Budget: Funds allocated to cover costs related to stress test review, legal reserach and legal setup structures for arrangers [Sta.5.2.1B].',
  },
  {
    id: '96',
    parentId: '89',
    name: 'Steakhouse/Strategic Finance',
    code: 'STKH',
    idPath: '63/89/96',
    codePath: 'atlas/scopes/STA/STKH',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/governance_scope(GOV).svg',
    description:
      'Steakhouse Budget: Funds allocated to cover costs  related to the SKY Protocol financial reporting to help assess the health of the protocol [N/A]. This budget is terminated. Steakhouse will request funding from the Launch Project Budget.',
  },
  {
    id: '97',
    parentId: '63',
    name: 'Governance Scope',
    code: 'GOV',
    idPath: '63/97',
    codePath: 'atlas/scopes/GOV',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/governance_scope(GOV).svg',
    description: 'Ecosystem Governance Management',
  },
  {
    id: '98',
    parentId: '97',
    name: 'Advisory council project budget',
    code: 'GAC',
    idPath: '63/97/98',
    codePath: 'atlas/scopes/GOV/GAC',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/governance_scope(GOV).svg',
    description:
      'Advisory Council Project Budget: Funds allocated to cover costs  related to Advisory Council specific projects to improve the Scope Artifact Framework [Gov.1.1.5.1B].',
  },
  {
    id: '99',
    parentId: '97',
    name: 'Active Facilitators',
    code: 'AF',
    idPath: '63/97/99',
    codePath: 'atlas/scopes/GOV/AF',
    image: '',
    description: 'Facilitators responsible for each of the Scopes [Gov.7.1].',
  },
  {
    id: '100',
    parentId: '99',
    name: 'Governance Facilitator Jansky',
    code: 'gov-facilitator-Jansky',
    idPath: '63/97/99/100',
    codePath: 'atlas/scopes/GOV/AF/gov-facilitator-Jansky',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/governance_scope(GOV).svg',
    description:
      'Governance Facilitator Jansky Budget: Funds allocated to cover costs  related to the Governance facilitator´s work [Gov.7.1.1.1.1A].',
  },
  {
    id: '101',
    parentId: '99',
    name: 'Governance Facilitator Endgame Edge',
    code: 'gov-facilitator-EndgameEdge',
    idPath: '63/97/99/101',
    codePath: 'atlas/scopes/GOV/AF/gov-facilitator-EndgameEdge',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/governance_scope(GOV).svg',
    description:
      'Governance Facilitator Endgame Edge Budget: Funds allocated to cover costs  related to the Governance facilitator´s work [Gov.7.1.1.1.1A].',
  },
  {
    id: '102',
    parentId: '99',
    name: 'Ecosystem',
    code: 'ECO-001',
    idPath: '63/97/99/102',
    codePath: 'atlas/scopes/GOV/AF/ECO-001',
    image: '',
    description:
      'Governance Facilitator Endgame Edge Budget: Funds allocated to cover costs  related to the Governance facilitator´s work [Gov.7.1.1.1.1A].',
  },
  {
    id: '103',
    parentId: '99',
    name: 'GovAlpha-001',
    code: 'GVL-001',
    idPath: '63/97/99/103',
    codePath: 'atlas/scopes/GOV/AF/GVL-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/governance_scope(GOV).svg',
    description:
      'GovAlpha Budget: Funds allocated to cover costs  related to the governance facilitator work [Gov.7.1.1.1.1A]. ',
  },
  {
    id: '104',
    parentId: '63',
    name: 'Protocol Scope',
    code: 'PRO',
    idPath: '63/104',
    codePath: 'atlas/scopes/PRO',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/protocol_scope(PRO).svg',
    description: 'Core Protocol Management',
  },
  {
    id: '105',
    parentId: '104',
    name: 'Aave',
    code: 'AAVE-001',
    idPath: '63/104/105',
    codePath: 'atlas/scopes/PRO/AAVE-001',
    image: '',
    description: '',
  },
  {
    id: '106',
    parentId: '104',
    name: 'The Protocol Advisory Council project',
    code: 'PAC',
    idPath: '63/104/106',
    codePath: 'atlas/scopes/PRO/PAC',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/protocol_scope(PRO).svg',
    description:
      'The Advisory Council Project Budget: Funds allocated to cover costs  related to Advisory Council Projects [Pro.1.1.4.1B].',
  },
  {
    id: '107',
    parentId: '104',
    name: 'PullUp Labs',
    code: 'PUL-001',
    idPath: '63/104/107',
    codePath: 'atlas/scopes/PRO/PUL-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'PullUp Budget: Funds allocated to cover costs  related to Innovation Engireering including Smart Burn Engine, Sagittarius Engine, SubDAO launch and SKY NewChain [SUP.7.4.2.1A].',
  },
  {
    id: '108',
    parentId: '104',
    name: 'dewiz',
    code: 'DEW-001',
    idPath: '63/104/108',
    codePath: 'atlas/scopes/PRO/DEW-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Dewiz Budget: Funds allocated to cover costs related to general smart contract development and RWA collateral onboarding technical work [SUP.7.4.2.1A].',
  },
  {
    id: '109',
    parentId: '104',
    name: 'Maker NewChain bootstrapping/NewChain',
    code: 'NEW-C',
    idPath: '63/104/109',
    codePath: 'atlas/scopes/PRO/NEW-C',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/protocol_scope(PRO).svg',
    description:
      'The NewChain Budget: Funds allocated to cover costs  related to NewChain bootstrapping projects [Pro.2.1.2B].',
  },
  {
    id: '110',
    parentId: '104',
    name: 'Multichain engineering',
    code: 'MULTI-C',
    idPath: '63/104/110',
    codePath: 'atlas/scopes/PRO/MULTI-C',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/89def08f5e56fba5aef97cca6c011ad067a1ab80/ecosystem-dashboard/budgets/protocol_scope(PRO).svg',
    description:
      'The Multichain Engineering Budget: Funds allocated to cover costs  related to Multichain engineering work and limited bootstrapping pusposes of other technologies in addition to the Two-Stage Bridge [Pro.4.1.1B].',
  },
  {
    id: '111',
    parentId: '104',
    name: 'Governance Security engineering',
    code: 'GSE',
    idPath: '63/104/111',
    codePath: 'atlas/scopes/PRO/GSE',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/protocol_scope(PRO).svg',
    description:
      'The Governance Security Engineering Budget: Funds allocated to cover costs  related to the development and deployment of spells [Pro.11.1.1B].',
  },
  {
    id: '112',
    parentId: '104',
    name: 'Sidestream',
    code: 'SSA-001',
    idPath: '63/104/112',
    codePath: 'atlas/scopes/PRO/SSA-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/support_scope(SUP).svg',
    description:
      'Sidestream Budget: Funds allocated to cover costs  related to full stack smart contract and front end development [SUP.7.4.2.1A].',
  },
  {
    id: '113',
    parentId: '104',
    name: 'Keepers',
    code: 'KPRS',
    idPath: '63/104/113',
    codePath: 'atlas/scopes/PRO/KPRS',
    image: '',
    description:
      'Keepers Budget: Funds allocated to cover keeper network. Estimating the cost based on one of the day’s usage shows about 25m gas usage per day which at 100 gwei means 2.5 ETH / day in expenses or about 1,250 DAI / day / network assuming $2000 ETH. If the gas isn’t spent it is returned to the surplus buffer automatically.',
  },
  {
    id: '114',
    parentId: '113',
    name: 'Gelato',
    code: 'GE',
    idPath: '63/104/113/114',
    codePath: 'atlas/scopes/PRO/KPRS/GE',
    image: '',
    description: '',
  },
  {
    id: '115',
    parentId: '113',
    name: 'KEEP3R',
    code: 'KE',
    idPath: '63/104/113/115',
    codePath: 'atlas/scopes/PRO/KPRS/KE',
    image: '',
    description: '',
  },
  {
    id: '116',
    parentId: '113',
    name: 'CHAINLINK',
    code: 'CH',
    idPath: '63/104/113/116',
    codePath: 'atlas/scopes/PRO/KPRS/CH',
    image: '',
    description: '',
  },
  {
    id: '117',
    parentId: '113',
    name: 'Techops Services Parameters',
    code: 'TS',
    idPath: '63/104/113/117',
    codePath: 'atlas/scopes/PRO/KPRS/TS',
    image: '',
    description: '',
  },
  {
    id: '118',
    parentId: '63',
    name: 'Accessibility Scope',
    code: 'ACC',
    idPath: '63/118',
    codePath: 'atlas/scopes/ACC',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description: 'Ecosystem Accessibility Management',
  },
  {
    id: '119',
    parentId: '118',
    name: 'The Advisory Council project budget',
    code: 'AAC',
    idPath: '63/118/119',
    codePath: 'atlas/scopes/ACC/AAC',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description:
      'Accessibility Council Project Budget: Funds allocated to cover costs  related to Advisory Council projects to improve all or specific parts of the content of the Accessibility Scope Artifact [Acc.1.1.4.1B].',
  },
  {
    id: '120',
    parentId: '118',
    name: 'Rebrand Budget',
    code: 'RBRD',
    idPath: '63/118/120',
    codePath: 'atlas/scopes/ACC/RBRD',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description: '',
  },
  {
    id: '121',
    parentId: '118',
    name: 'Accessibility Reward',
    code: 'accessReward',
    idPath: '63/118/121',
    codePath: 'atlas/scopes/ACC/accessReward',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description: '',
  },
  {
    id: '122',
    parentId: '118',
    name: 'Accessibility communication channel Budget',
    code: 'accessComs',
    idPath: '63/118/122',
    codePath: 'atlas/scopes/ACC/accessComs',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description:
      'The Accessibility Communication Channel Budget: Funds allocated to cover costs  related to Communication [Acc.4.3.1.1A].',
  },
  {
    id: '123',
    parentId: '118',
    name: 'Endgame Launch Project Budget',
    code: 'ELP',
    idPath: '63/118/123',
    codePath: 'atlas/scopes/ACC/ELP',
    image: '',
    description:
      'The Launch Project Budget: Funds allocated to cover costs related to the development of the new brand with website, marketing, and communications strategy [Acc.9.1.1B].',
  },
  {
    id: '124',
    parentId: '123',
    name: 'Launch Project Budget',
    code: 'ELP-001.a',
    idPath: '63/118/123/124',
    codePath: 'atlas/scopes/ACC/ELP/ELP-001.a',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description: '',
  },
  {
    id: '125',
    parentId: '123',
    name: 'Launch Project Budget',
    code: 'ELP-001.b',
    idPath: '63/118/123/125',
    codePath: 'atlas/scopes/ACC/ELP/ELP-001.b',
    image: '',
    description:
      'The budget available for the Launch Project is specified in 9.1.1B. It is a one time budget that doesn’t renew over time, and payouts from the budget can be triggered by a message in the Maker Core forum specifying the amount to pay out (for lump sum payments) or the dssvest parameters (for dssvest payments), and the recipient address. The payment is bundled directly into the next weekly Executive Vote without requiring a Governance Poll. Every time a payout is done, the remaining budget in 9.1.1B must be reduced to reflect the spent amount. Spending cannot exceed the total budget one-time budget.',
  },
  {
    id: '126',
    parentId: '123',
    name: 'Powerhouse',
    code: 'PH-001',
    idPath: '63/118/123/126',
    codePath: 'atlas/scopes/ACC/ELP/PH-001',
    image: '',
    description: '',
  },
  {
    id: '127',
    parentId: '123',
    name: 'Pointable',
    code: 'PNT-001',
    idPath: '63/118/123/127',
    codePath: 'atlas/scopes/ACC/ELP/PNT-001',
    image: '',
    description: '',
  },
  {
    id: '128',
    parentId: '123',
    name: 'Jetstream',
    code: 'JTS-001',
    idPath: '63/118/123/128',
    codePath: 'atlas/scopes/ACC/ELP/JTS-001',
    image: '',
    description: '',
  },
  {
    id: '129',
    parentId: '128',
    name: 'Jetstream Starting Budget',
    code: 'JTS-001.a',
    idPath: '63/118/123/128/129',
    codePath: 'atlas/scopes/ACC/ELP/JTS-001/JTS-001.a',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description:
      'Jetstream Budget: Available to be used on work related to frontend code, app delivery method, data handling & UX [Acc.9.1.1B].',
  },
  {
    id: '130',
    parentId: '128',
    name: 'Jetstream Budget Stream',
    code: 'JTS-001.b',
    idPath: '63/118/123/128/130',
    codePath: 'atlas/scopes/ACC/ELP/JTS-001/JTS-001.b',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description:
      'Jetstream Budget: Available to be used in work related to work on frontend code, app delivery methis, data handling & UX [Acc.9.1.1B].',
  },
  {
    id: '131',
    parentId: '123',
    name: 'Marketing and Branding',
    code: 'marketing&branding',
    idPath: '63/118/123/131',
    codePath: 'atlas/scopes/ACC/ELP/marketing&branding',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description:
      'The Launch Project Budget: Funds allocated to cover costs  related to the development of the new brand with website, marketing, and communications strategy [Acc.9.1.1B].',
  },
  {
    id: '132',
    parentId: '123',
    name: 'Growth wallet holding to fund branding expenses "requested by Ecosystem Team"',
    code: 'growth-wallet',
    idPath: '63/118/123/132',
    codePath: 'atlas/scopes/ACC/ELP/growth-wallet',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/accessibility_scope_(ACC).svg',
    description:
      'Growth Budget: Funds allocated to cover costs  related to marketing, branding and growth work to building the new brand [Acc.9.1.1B]',
  },
  {
    id: '133',
    parentId: null,
    name: 'MakerDAO Legacy Budget',
    code: 'atlas/legacy',
    idPath: '133',
    codePath: 'atlas/legacy',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/16f73df6917a57915cd07e79f7a42e55293b8225/ecosystem-dashboard/budgets/makerDAO_legacy_budgets.svg',
    description: 'Pre-Endgame expense data from the period 2021-2023.',
  },
  {
    id: '134',
    parentId: '133',
    name: 'Core Units',
    code: 'core-units',
    idPath: '133/134',
    codePath: 'atlas/legacy/core-units',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/89def08f5e56fba5aef97cca6c011ad067a1ab80/ecosystem-dashboard/budgets/core_units_finances.svg',
    description:
      'Operational Effective Oversight: Pre-endgame expense data from the period 2021-2023. ',
  },
  {
    id: '135',
    parentId: '134',
    name: 'Deco Protocol',
    code: 'DECO-001',
    idPath: '133/134/135',
    codePath: 'atlas/legacy/core-units/DECO-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/deco-001/DECO_logo.png',
    description:
      'DECO-001 Budget: Funds allocated to cover compensation, maintenance and operations for the benefit of MakerDAO.',
  },
  {
    id: '136',
    parentId: '134',
    name: 'Oracles',
    code: 'ORA-001',
    idPath: '133/134/136',
    codePath: 'atlas/legacy/core-units/ORA-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/ora-001/ora_logo.png',
    description: 'ORA-001 Budget: ',
  },
  {
    id: '137',
    parentId: '134',
    name: 'Sustainable Ecosystem Scaling',
    code: 'SES-001',
    idPath: '133/134/137',
    codePath: 'atlas/legacy/core-units/SES-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/ses-001/logo.png',
    description:
      'SES-001 Budget: Funds allocated to cover software development, maintenance and operations for the benefit of MakerDAO.',
  },
  {
    id: '138',
    parentId: '134',
    name: 'TechOps',
    code: 'TECH-001',
    idPath: '133/134/138',
    codePath: 'atlas/legacy/core-units/TECH-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/tech-001/tech_logo.png',
    description:
      'TECH-001 Budget: Funds allocated to cover cost related to system administration and technical support needs of the Maker Protocol.',
  },
  {
    id: '139',
    parentId: '134',
    name: 'Sidestream Auction Services',
    code: 'SAS-001',
    idPath: '133/134/139',
    codePath: 'atlas/legacy/core-units/SAS-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/sas-001/SAS_logo.png',
    description: 'SAS-001 Budget:',
  },
  {
    id: '140',
    parentId: '134',
    name: 'Immunefi Security',
    code: 'IS-001',
    idPath: '133/134/140',
    codePath: 'atlas/legacy/core-units/IS-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/is-001/IS_logo.png',
    description: 'IS-001 Budget: Funds allocated to cover cost related to Bug Bounties.',
  },
  {
    id: '141',
    parentId: '134',
    name: 'Development & UX',
    code: 'DUX-001',
    idPath: '133/134/141',
    codePath: 'atlas/legacy/core-units/DUX-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/dux-001/dux_logo.png',
    description:
      'DUX-001 Budget: Funds allocated to cover cost related to MakerDAO front end development and maintenance.',
  },
  {
    id: '142',
    parentId: '134',
    name: 'Starknet Engineering',
    code: 'SNE-001',
    idPath: '133/134/142',
    codePath: 'atlas/legacy/core-units/SNE-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/sne-001/SNE_logo.png',
    description: '',
  },
  {
    id: '143',
    parentId: '134',
    name: 'Collateral Engineering Services',
    code: 'CES-001',
    idPath: '133/134/143',
    codePath: 'atlas/legacy/core-units/CES-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/ces-001/ces_logo.png',
    description:
      'CES-001 Budget: Funds allocated to cover costs related to operations. This Core Unit supports the ongoing needs of on-chain (crypto native collateral), architect and implements off-chain rwa, onboard prospective collateral, maintain and operationalize all collateral within the Maker Protocol, and support the entire collateral lifecycle with product management best practices. ',
  },
  {
    id: '144',
    parentId: '134',
    name: 'Strategic Happiness',
    code: 'SH-001',
    idPath: '133/134/144',
    codePath: 'atlas/legacy/core-units/SH-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/sh-001/SH_logo.png',
    description:
      'SH:001 Budget: Funds allocated to cover costs related to marketing operations such as official MakerDAO swag and swag management.  ',
  },
  {
    id: '145',
    parentId: '134',
    name: 'Data Insights',
    code: 'DIN-001',
    idPath: '133/134/145',
    codePath: 'atlas/legacy/core-units/DIN-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/din-001/din_logo.png',
    description:
      'DIN-001 Budget: Funds allocated to cover costs related to building new datasets to cover L2s, RWAs and provide free and permissionless datasets with contextualized protocol data.',
  },
  {
    id: '146',
    parentId: '134',
    name: 'Dai Foundation',
    code: 'DAIF-001',
    idPath: '133/134/146',
    codePath: 'atlas/legacy/core-units/DAIF-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/daif-001/daif_logo.png',
    description:
      'DAIF-001 Budget: Funds allocated to sustain the operations related to the safeguarding of the protocol´s intellectual property and the implementation of processes for making the intellectual property that the Dai Foundation owns available for use by the broader Maker community. ',
  },
  {
    id: '147',
    parentId: '134',
    name: 'Governance Communications',
    code: 'COM-001',
    idPath: '133/134/147',
    codePath: 'atlas/legacy/core-units/COM-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/com-001/com_logo.png',
    description:
      'Com-001 Budget: Funds allocated to sustain operations related to  MakerDAO´s informational accessibility such as Stakeholder News and reports, Public-call summaries, Public calendars and communication platform stewardship.',
  },
  {
    id: '148',
    parentId: '134',
    name: 'Real-World Finance',
    code: 'RWF-001',
    idPath: '133/134/148',
    codePath: 'atlas/legacy/core-units/RWF-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/rwf-001/RWF_logo.png',
    description:
      'RWF-001 Budget: Funds allocated to cover the costs related to the onboarding of RWA.',
  },
  {
    id: '149',
    parentId: '134',
    name: 'Growth',
    code: 'GRO-001',
    idPath: '133/134/149',
    codePath: 'atlas/legacy/core-units/GRO-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/gro-001/gro_logo.png',
    description:
      'Growth-001 Budget: Funds allocated to cover the costs of adoption campaigns, educational content, and partner initiatives. ',
  },
  {
    id: '150',
    parentId: '134',
    name: 'Protocol Engineering',
    code: 'PE-001',
    idPath: '133/134/150',
    codePath: 'atlas/legacy/core-units/PE-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/pe-001/pe_logo.png',
    description: '',
  },
  {
    id: '151',
    parentId: '134',
    name: 'Risk',
    code: 'RISK-001',
    idPath: '133/134/151',
    codePath: 'atlas/legacy/core-units/RISK-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/risk-001/RISK_logo.png',
    description: '',
  },
  {
    id: '152',
    parentId: '134',
    name: 'Events',
    code: 'EVENTS-001',
    idPath: '133/134/152',
    codePath: 'atlas/legacy/core-units/EVENTS-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/events-001/EVENTS_logo.png',
    description: '',
  },
  {
    id: '153',
    parentId: '134',
    name: 'Governance Alpha',
    code: 'GOV-001',
    idPath: '133/134/153',
    codePath: 'atlas/legacy/core-units/GOV-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/gov-001/gov_logo.png',
    description:
      'This budget has been marked as obsolete as per the changes introduced in MIP40 via MIP102c2-SP1.',
  },
  {
    id: '154',
    parentId: '134',
    name: 'Content Production',
    code: 'MKT-001',
    idPath: '133/134/154',
    codePath: 'atlas/legacy/core-units/MKT-001',
    image: '',
    description: '',
  },
  {
    id: '155',
    parentId: '134',
    name: 'Strategic Finance',
    code: 'SF-001',
    idPath: '133/134/155',
    codePath: 'atlas/legacy/core-units/SF-001',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/main/ecosystem-dashboard/core-units/sf-001/SF_logo.png',
    description: '',
  },
  {
    id: '156',
    parentId: '133',
    name: 'SPFs',
    code: 'spfs',
    idPath: '133/156',
    codePath: 'atlas/legacy/spfs',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/89def08f5e56fba5aef97cca6c011ad067a1ab80/ecosystem-dashboard/budgets/SPFs.svg',
    description: 'Escrowed Dai',
  },
  {
    id: '157',
    parentId: '156',
    name: 'Phoenix Labs Initial Funding',
    code: 'SPF15',
    idPath: '133/156/157',
    codePath: 'atlas/legacy/spfs/SPF15',
    image: '',
    description:
      'This SPF requested a budget of 50,000 DAI for legal and incorporation expenses of Phoenix Labs, an R&D company focused on creating new products for MakerDAO.',
  },
  {
    id: '158',
    parentId: '156',
    name: 'Commercial Risk and Legal Domain Work to Support SF-001 Expanded Mandate Related to RWAs',
    code: 'SPF12',
    idPath: '133/156/158',
    codePath: 'atlas/legacy/spfs/SPF12',
    image: '',
    description:
      'This SPF requested a 209,000 DAI to support SF-001’s expanded mandate regarding RWAs. "This SPF provides funding for onboarding a structured finance consultant and legal counsel to perform commercial and legal risk analysis on RWAs greenlit by MKR holders and in consideration for onboarding. These contributors will also be responsible for monitoring RWA vaults and developing reporting to provide transparency of vault performance to the community. These individuals will also be helping structure the relationship between Maker Core, future ProtectorDAOs, and the Arrangers, focusing on defining key constraints with the help of the community to ensure Maker Core and DAI holders are protected as we all navigate implementation of the End Game Plan."',
  },
  {
    id: '159',
    parentId: '156',
    name: 'Legal & Risk Domain Work on Greenlit Collateral BlockTower Credit (RWA Arranger',
    code: 'SPF9',
    idPath: '133/156/159',
    codePath: 'atlas/legacy/spfs/SPF9',
    image: '',
    description:
      'This SPF requested a budget of 258,000 DAI to support onboarding BlockTower Credit as a RWA Arranger pursuant to the greenlight passing. This SPF provides funding for underwriting and performing the legal work necessary to onboard BlockTower Credit.',
  },
  {
    id: '160',
    parentId: '156',
    name: 'Legal Work on MIP65',
    code: 'SPF8',
    idPath: '133/156/160',
    codePath: 'atlas/legacy/spfs/SPF8',
    image: '',
    description:
      'This SPF requested a budget of 30,000 DAI reimbursement to SF-001 for advancing legal expenses relating to legal work in the context of MIP65. This SPF reimburses the Strategic Finance Core Unit (SF-001) team for the legal work he is doing on MIP65.',
  },
  {
    id: '161',
    parentId: '156',
    name: 'Special Purpose Fund for The Ambassador Program',
    code: 'SPF7',
    idPath: '133/156/161',
    codePath: 'atlas/legacy/spfs/SPF7',
    image: '',
    description:
      'This SPF requested a budget of 81,000 DAI to fund the Ambassador Program. The MakerDAO Ambassador program provides non-English speaking communities with resources and educational materials to expand the MakerDAO community. Ambassadors provide two-way translation services, engage their communities with local events, and share content produced in their language with the MakerDAO community.',
  },
  {
    id: '162',
    parentId: '156',
    name: 'Legal Domain Work on Greenlit Collateral (bIBTA',
    code: 'SPF6',
    idPath: '133/156/162',
    codePath: 'atlas/legacy/spfs/SPF6',
    image: '',
    description:
      'This SPF requested a 50,000 DAI advance for legal expenses relating to domain work in the context of the greenlit bIBTA application. The domain strategy for this collateral type is to evaluate the legal ramifications of onboarding a bIBTA vault. If the legal review is favorable, technical work can continue. If the legal review is unfavorable, it follows to avoid further investment and recommend deprioritizing.',
  },
  {
    id: '163',
    parentId: '156',
    name: 'ETHAmsterdam Event SPF',
    code: 'SPF3',
    idPath: '133/156/163',
    codePath: 'atlas/legacy/spfs/SPF3',
    image: '',
    description:
      'This SPF requested a budget of 50,000 DAI for the MakerDAO event in Amsterdam scheduled between April 20-24, 2022.',
  },
  {
    id: '164',
    parentId: '156',
    name: 'Classified SPF',
    code: 'SPFx',
    idPath: '133/156/164',
    codePath: 'atlas/legacy/spfs/SPFx',
    image: '',
    description: 'N/A',
  },
  {
    id: '165',
    parentId: '133',
    name: 'Keepers',
    code: 'keepers',
    idPath: '133/165',
    codePath: 'atlas/legacy/keepers',
    image: '',
    description: 'Legacy keepers expense data from before May 2023. ',
  },
  {
    id: '166',
    parentId: '133',
    name: 'Recognized Delegates',
    code: 'recognized-delegates',
    idPath: '133/166',
    codePath: 'atlas/legacy/recognized-delegates',
    image:
      'https://raw.githubusercontent.com/makerdao-ses/makerdao-ses.github.io/89def08f5e56fba5aef97cca6c011ad067a1ab80/ecosystem-dashboard/budgets/recognized_delegates.svg',
    description: 'Pre-endgame expense data from the period 2021-2023. ',
  },
  {
    id: '167',
    parentId: '133',
    name: 'Uncategorized',
    code: 'uncategorized',
    idPath: '133/167',
    codePath: 'atlas/legacy/uncategorized',
    image: '',
    description: '',
  },
]
